/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Always-active entitlements checked in real-time on every relevant request. XP_MULTIPLIER and STREAK_BOOST use the multiplier field. FEATURE_ACCESS uses the feature field (e.g. "LEVEL_4_ACCESS").
 * 
 * @export
 */
export const TierEntitlementType = {
    XP_MULTIPLIER: 'XP_MULTIPLIER',
    FEATURE_ACCESS: 'FEATURE_ACCESS',
    STREAK_BOOST: 'STREAK_BOOST'
} as const;
export type TierEntitlementType = typeof TierEntitlementType[keyof typeof TierEntitlementType];


export function instanceOfTierEntitlementType(value: any): boolean {
    for (const key in TierEntitlementType) {
        if (Object.prototype.hasOwnProperty.call(TierEntitlementType, key)) {
            if (TierEntitlementType[key as keyof typeof TierEntitlementType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TierEntitlementTypeFromJSON(json: any): TierEntitlementType {
    return TierEntitlementTypeFromJSONTyped(json, false);
}

export function TierEntitlementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TierEntitlementType {
    return json as TierEntitlementType;
}

export function TierEntitlementTypeToJSON(value?: TierEntitlementType | null): any {
    return value as any;
}

export function TierEntitlementTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TierEntitlementType {
    return value as TierEntitlementType;
}

